module.exports = __webpack_public_path__ + "img/lava.538e1ae5.jpg";